var u = 800, i = 16, o = Date.now;
function s(n) {
  var t = 0, r = 0;
  return function() {
    var a = o(), e = i - (a - r);
    if (r = a, e > 0) {
      if (++t >= u)
        return arguments[0];
    } else
      t = 0;
    return n.apply(void 0, arguments);
  };
}
var f = s;
export {
  f as default
};
//# sourceMappingURL=_shortOut.js.map
